// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"I9-z"};